// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".testfail-ok-button {\n  background-color: rgb(41, 41, 41);\n  border: none;\n  border-radius: 5px;\n  color: white;\n  font-size: 15px;\n  text-align: center;\n  margin-right: 5px;\n  box-shadow: 0 1px 4px 0px black;\n}\n\n.testfail-ok-button:hover {\n  background-color: rgb(41, 41, 41);\n  color: #efa718 !important;\n}\n\n.testfail-ok-button:hover:focus {\n  background-color: rgb(41, 41, 41);\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
